import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAuth0Component } from './simple-icons-auth0.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAuth0Component ],
    exports:      [ SimpleIconsAuth0Component ],
    bootstrap:    []
})
export class SimpleIconsAuth0Module {}
